module.exports = __webpack_public_path__ + "static/media/album-white.278fa8a4.png";